import React from "react";
import img1 from "./images/illustration/personal-trainer-img-4.jpg";


const Contact = () => {
  return (
    <>
      <div className="container-fluid g-0" id="image3">
        <div className="row">
          <div className="col-12">
            <h2 className="text-white fw-bold heading">
              <span className="text-warning"> CONTACT US</span>
            </h2>
            <p className="fw-bold text-white fs-5">BACK HOME</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-12 col-md-6 col-xl-4 mt-4">
          <div className="icons">
            <i class="fas fa-map-marker"></i>
          </div>
          <h2>Address</h2>
          <p className="fw-bold">8502 Preston Rd. Inglewood, Maine 98380</p>
        </div>
        <div className="col-12 col-md-6 col-xl-4 mt-4">
          <div className="icons">
            <i class="fas fa-phone"></i>
            <h2>Phone</h2>
            <p className="fw-bold">
              (808) 555-0111 <br />
              (208) 555-0112
            </p>
          </div>
        </div>
        <div className="col-12 col-md-6 col-xl-4 mt-4">
          <div className="icons">
            <i class="fas fa-envelope"></i>
            <h2>E-Mail</h2>
            <p className="fw-bold">kenzi.lawson@example.com <br /> georgia.young@example.com</p>
          </div>
        </div>
      </div>
      <div className="row mt-5">
      <div className="col-12 col-md-6">

        <img src={img1} alt="image not found" className="img-fluid" />
        </div>
        <div className="col-12 col-md-6 mt-5">
            <h2 className="heading fw-bold mb-4">HAVE ANY QUESTIONS?</h2>
            <form>
            <div class="mb-3 mt-5">
              <label for="exampleInputEmail1" class="form-label">
                NAME
              </label>
              <input></input>
              <div id="emailHelp" class="form-text"></div>
            </div>
            <div class="mb-3 mt-5">
              <label for="exampleInputPassword1" class="form-label">
                E-MAIL
              </label>
              <input></input>
            </div>
            <div class="mb-3 form-check mt-5">
              <input></input>
              <label class="form-check-label">YOUR QUESTION</label>
            </div>
            <button type="submit" class="btn btn-primary">
              Submit
            </button>
          </form>


        </div>
        

      </div>

      <div className="row bg-dark text-white">
      <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>WoxFit</h1>
              <p className="set2">
                Parturient porttitor quam mattis ipsum imperdiet habitasse orci.
                Risus integer.
              </p>
              <div className="icons">
              <i class="fab fs-3 me-4 fa-instagram"></i>
              <i class="fab fs-3 me-4 fa-twitter"></i>
              <i class="fab fs-3 me-4 fa-facebook"></i>

              </div>
            </div>
            <div className=" col-12 col-md-6 col-xl-3 mt-5 ">
              <h1>About</h1>
              <p className="set5">About us</p>
              <p className="set5">Blog</p>
              <p className="set5">Careers</p>
              <p className="set5">Jobs</p>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>Services</h1>
              <p className="box10">How we work</p>
              <p className="box10">Portfolio</p>
              <p className="box10">Pricing</p>
              <p className="box10">More</p>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-5">
              <h1>Support</h1>
              <p>Contact us</p>
              <p>online chat</p>
              <p>Whatsapp</p>
              <p>Telegram</p>
              
            </div>
       
      </div>
    </>
  );
};
export default Contact;
